import * as angular from "angular";
import {sidebar} from "./sidebar/sidebar";
import {cleverMatchLanding} from "./clever-match-landing/clever-match-landing";
import {cleverMatchLandingV2} from "./clever-match-landing-v2/clever-match-landing-v2";
import {matchPreview} from "./match-preview/match-preview";
import {matchDetails} from "./match-details/match-details";
import {matchHistory} from "./match-history/match-history";
import {progressMenu} from "./common/progress-menu/progress-menu";
import {tabsMenu} from "./common/tabs-menu/tabs-menu";
import {studentTestImport} from "./student-test-import/student-test-import";
import {progressBar} from "./common/progress-bar/progress-bar";
import {downloadCsv} from "./common/download-csv/download-csv";
import {studentImportRecords} from "./student-import-records/student-import-records";
import {progressHeader} from "./common/progress-header/progress-header";
import {staffTestImport} from "./staff-test-import/staff-test-import";
import {staffImportRecords} from "./staff-import-records/staff-import-records";
import {staffRoles} from "./staff-roles/staff-roles";
import {importStudentData} from "./import-student-data/import-student-data";
import {importStaffData} from "./import-staff-data/import-staff-data";
import {testImportDrawer} from "./test-import-drawer/test-import-drawer";
import {collapsible} from "./collapsible/collapsible";

export function initComponents(app: angular.IModule) {
    app.directive("sidebar", () => sidebar);
    app.directive("cleverMatchLanding", () => cleverMatchLanding);
    app.directive("cleverMatchLandingV2", () => cleverMatchLandingV2);
    app.directive("matchPreview", () => matchPreview);
    app.directive("matchDetails", () => matchDetails);
    app.directive("matchHistory", () => matchHistory);
    app.directive("progressMenu", () => progressMenu);
    app.directive("tabsMenu", () => tabsMenu);
    app.directive("studentTestImport", () => studentTestImport);
    app.directive("progressBar", () => progressBar);
    app.directive("downloadCsv", () => downloadCsv);
    app.component("studentImportRecords", studentImportRecords);
    app.component("progressHeader", progressHeader);
    app.directive("staffTestImport", () => staffTestImport);
    app.directive("staffImportRecords", () => staffImportRecords);
    app.directive("staffRoles", () => staffRoles);
    app.directive("importStudentData", () => importStudentData);
    app.directive("importStaffData", () => importStaffData);
    app.directive("testImportDrawer", () => testImportDrawer);
    app.directive("collapsible", () => collapsible);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/app.components.ts